import type { BspBettingCapability } from "../contract";

type BspMarket = {
  bspBettingAllowed?: boolean;
  inplay?: boolean;
};

export const isBspEligible = (capability: BspBettingCapability, market: BspMarket | undefined): boolean => {
  if (!capability.enabled || !market) {
    return false;
  }

  return !!market.bspBettingAllowed && !market.inplay;
};
